import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Check } from './icons';
export function NumberedListIcon({ size = 18 }) {
    return (<svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
      {/* 1 */}
      <text x="1" y="6.5" fill="#0284c7" fontSize="6.5" fontWeight="700" fontFamily="system-ui, -apple-system, sans-serif">1</text>
      <line x1="7.5" y1="4.5" x2="18.5" y2="4.5" stroke="#334155" strokeWidth="1.7" strokeLinecap="round"/>
      {/* 2 */}
      <text x="1" y="12" fill="#0284c7" fontSize="6.5" fontWeight="700" fontFamily="system-ui, -apple-system, sans-serif">2</text>
      <line x1="7.5" y1="10" x2="18.5" y2="10" stroke="#334155" strokeWidth="1.7" strokeLinecap="round"/>
      {/* 3 */}
      <text x="1" y="17.5" fill="#0284c7" fontSize="6.5" fontWeight="700" fontFamily="system-ui, -apple-system, sans-serif">3</text>
      <line x1="7.5" y1="15.5" x2="18.5" y2="15.5" stroke="#334155" strokeWidth="1.7" strokeLinecap="round"/>
    </svg>);
}
const LIST_STYLES = [
    {
        id: 'decimal',
        label: 'Numbers (1. 2. 3.)',
        category: 'Standard',
        samples: ['1. Item one', '2. Item two', '3. Item three'],
    },
    {
        id: 'lower-alpha',
        label: 'Alphabet Lowercase (a. b. c.)',
        category: 'Alphabetic',
        samples: ['a. Item one', 'b. Item two', 'c. Item three'],
    },
    {
        id: 'upper-alpha',
        label: 'Alphabet Uppercase (A. B. C.)',
        category: 'Alphabetic',
        samples: ['A. Item one', 'B. Item two', 'C. Item three'],
    },
    {
        id: 'lower-roman',
        label: 'Roman Lowercase (i. ii. iii.)',
        category: 'Roman Numerals',
        samples: ['i. Item one', 'ii. Item two', 'iii. Item three'],
    },
    {
        id: 'upper-roman',
        label: 'Roman Uppercase (I. II. III.)',
        category: 'Roman Numerals',
        samples: ['I. Item one', 'II. Item two', 'III. Item three'],
    },
];
export function ListStyleSelector({ editor }) {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);
    useEffect(() => {
        function handleClickOutside(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);
    if (!editor)
        return null;
    const isOrderedActive = editor.isActive('orderedList');
    const currentStyle = editor.getAttributes('orderedList')?.listStyleType || 'decimal';
    const handleToggleDefault = (e) => {
        e.preventDefault();
        if (isOrderedActive) {
            editor.chain().focus().toggleOrderedList().run();
        }
        else {
            editor.chain().focus().toggleOrderedList().updateAttributes('orderedList', { listStyleType: 'decimal' }).run();
        }
    };
    const handleSelectStyle = (styleId) => {
        if (!isOrderedActive) {
            editor
                .chain()
                .focus()
                .toggleOrderedList()
                .updateAttributes('orderedList', { listStyleType: styleId })
                .run();
        }
        else {
            editor
                .chain()
                .focus()
                .updateAttributes('orderedList', { listStyleType: styleId })
                .run();
        }
        setIsOpen(false);
    };
    const handleRemoveList = () => {
        if (isOrderedActive) {
            editor.chain().focus().toggleOrderedList().run();
        }
        setIsOpen(false);
    };
    return (<div className="list-style-selector-container" ref={containerRef} style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      <div className={`toolbar-btn-group ${isOrderedActive ? 'is-active' : ''}`} style={{
            display: 'inline-flex',
            alignItems: 'center',
            borderRadius: '6px',
            border: '1px solid transparent',
            backgroundColor: isOrderedActive ? '#eff6ff' : 'transparent',
        }}>
        <button type="button" className={`toolbar-btn ${isOrderedActive ? 'is-active' : ''}`} onClick={handleToggleDefault} title="Toggle Numbered List" style={{
            padding: '4px 6px',
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '32px',
        }}>
          <NumberedListIcon size={18}/>
        </button>

        <button type="button" className={`toolbar-btn ${isOpen ? 'is-active' : ''}`} onClick={() => setIsOpen(!isOpen)} title="Numbered List Options (Numbers, Alphabetic, Roman Numerals)" style={{
            padding: '4px 3px',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderLeft: '1px solid rgba(0,0,0,0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '32px',
        }}>
          <ChevronDown size={12} style={{ opacity: 0.7 }}/>
        </button>
      </div>

      {isOpen && (<div className="list-style-popover" style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                marginTop: '6px',
                background: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
                padding: '8px',
                display: 'flex',
                flexDirection: 'column',
                gap: '6px',
                zIndex: 1000,
                width: '280px',
                maxHeight: '400px',
                overflowY: 'auto',
            }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 8px' }}>
            <span style={{ fontSize: '11px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Numbering Library
            </span>
            {isOrderedActive && (<button type="button" onClick={handleRemoveList} style={{
                    background: 'none',
                    border: 'none',
                    color: '#ef4444',
                    fontSize: '11px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    padding: '2px 4px',
                    borderRadius: '4px',
                }}>
                Clear List
              </button>)}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '4px' }}>
            {LIST_STYLES.map((style) => {
                const isSelected = isOrderedActive && currentStyle === style.id;
                return (<button key={style.id} type="button" onClick={() => handleSelectStyle(style.id)} style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '8px 10px',
                        borderRadius: '6px',
                        border: isSelected ? '1.5px solid #2563eb' : '1px solid #f1f5f9',
                        backgroundColor: isSelected ? '#eff6ff' : '#f8fafc',
                        cursor: 'pointer',
                        textAlign: 'left',
                        transition: 'all 0.15s ease',
                    }} onMouseEnter={(e) => {
                        if (!isSelected)
                            e.currentTarget.style.backgroundColor = '#f1f5f9';
                    }} onMouseLeave={(e) => {
                        if (!isSelected)
                            e.currentTarget.style.backgroundColor = '#f8fafc';
                    }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    <div style={{ fontSize: '12px', fontWeight: 600, color: isSelected ? '#1e40af' : '#334155' }}>
                      {style.label}
                    </div>
                    <div style={{ fontSize: '11px', color: '#64748b', fontFamily: 'monospace', lineHeight: 1.3 }}>
                      <div>{style.samples[0]}</div>
                      <div>{style.samples[1]}</div>
                      <div>{style.samples[2]}</div>
                    </div>
                  </div>
                  {isSelected && <Check size={16} color="#2563eb" style={{ flexShrink: 0 }}/>}
                </button>);
            })}
          </div>
        </div>)}
    </div>);
}
